import {useContext} from "react";
import {StoreContext} from "../../../stores/StoreLoader";
import styles from "../styles/HeaderShortcuts.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import ClickableLink from "../../utilities/ClickableLink";
import classNames from "classnames";

export function Shortcut(props: {
    shortcut: Navigation,
    deleteNavigation: (id: number) => void,
    updateNavigation: (navigation: Navigation) => void,
    className?: string,
    canEdit: boolean,
}) {
    const {organizationStore} = useContext(StoreContext);

    const popupClassName = classNames({
        [styles.popup]: true,
        [styles.popupTitle]: props.canEdit && (props.shortcut.parent === organizationStore.currentOrganization.id),
    });

    return (
        <li className={props.className}>
            <div className={styles.popup}>
                {props.canEdit && <div>
                    <button style={{marginRight: '5px'}} title={"Edit Link"} onClick={() => props.updateNavigation(props.shortcut)}>
                        <FontAwesome ariaHidden name={'fa-pen'} prefix={'fas'} />
                    </button>
                    <button title={"Delete Link"} onClick={() => props.deleteNavigation(props.shortcut.id)}>
                        <FontAwesome ariaHidden name={'fa-trash'} prefix={'fas'} />
                    </button>
                </div>}
            </div>
            <ClickableLink href={props.shortcut.url} aria-label={props.shortcut.title}>
                <FontAwesome fixedWidth name={props.shortcut.icon} ariaHidden={true} />
                <div className={popupClassName}>
                    <div>
                        {props.shortcut.title}
                    </div>
                </div>
            </ClickableLink>
        </li>
    )
}
